import { useState } from 'react';
import { Link } from 'react-router-dom';
import './BoardMembers.css';

const members = [
  {
    name: 'Pastor Lowell U. Collins',
    title: 'Board Member',
    img: '/img/drcolins.JPG',
    location: 'United States',
    bio: 'Pastor Lowell U. Collins is the seventh child born to the late Brother Artie and late Mother Marian Collins. Pastor Collins has authored two books and has preached the Word of God across multiple nations. He was ordained an Elder under the spiritual leadership of the late Bishop William L. Bonner. His mission abroad included establishing churches in Germany, Norway, and Romania. Pastor Collins sees himself as a brother-minister and servant, one who loves the "old time way", and is constantly seeking means of providing humanitarian services to the less fortunate. He continues to promote unity in the Body of Christ.',
    experience: '25+ Years Experience',
  },
  {
    name: 'Bishop Jude',
    title: 'Board Member',
    img: '/img/bishopjude.jpg',
    location: 'Nigeria / Africa',
    bio: 'Bishop Jude is a dedicated church leader and humanitarian worker, committed to advancing the Gospel across Africa and beyond. He brings years of pastoral experience and a deep heart for mission work to the New Birth CCCI board.',
    experience: 'Senior Bishop',
  },
  {
    name: 'Bishop Solomon',
    title: 'Board Member',
    img: '/img/bishopsolomon.jpg',
    location: 'Africa',
    bio: 'Bishop Solomon is a seasoned minister with a passion for church planting, evangelism, and discipleship. He represents the African fellowship of New Birth CCCI and brings wisdom and experience to the board.',
    experience: 'Senior Bishop',
  },
  {
    name: 'Bishop Errol Sterling',
    title: 'Board Member',
    img: '/img/bishopsterling.jpg',
    location: 'Caribbean / Canada',
    bio: 'Bishop Errol Sterling is a respected leader in the body of Christ, known for his integrity, wisdom, and commitment to ministerial excellence. He serves faithfully on the New Birth CCCI board, contributing to the growth and governance of the organization.',
    experience: 'Senior Bishop',
  },
];

function MemberModal({ member, onClose }) {
  if (!member) return null;
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close">✕</button>
        <div className="modal-inner">
          <img src={member.img} alt={member.name} className="modal-img" />
          <div className="modal-body">
            <p className="modal-exp">{member.experience}</p>
            <h2>{member.name}</h2>
            <p className="modal-title-role">{member.title} · {member.location}</p>
            <p className="modal-bio">{member.bio}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function BoardMembers() {
  const [selected, setSelected] = useState(null);

  return (
    <>
      <div className="page-banner">
        <h1>Board Members</h1>
        <p>The leaders guiding our global mission</p>
        <nav className="breadcrumb">
          <Link to="/">Home</Link>
          <span>/</span>
          <span>Board Members</span>
        </nav>
      </div>

      <section className="board-section">
        <div className="container">
          <div className="section-header-center" style={{ marginBottom: '3rem' }}>
            <p className="section-label">Leadership</p>
            <h2 className="section-title">Meet Our <span>Board Members</span></h2>
            <p className="board-sub">
              Our diverse board of bishops and pastors brings decades of ministry experience and
              a global perspective to the work of New Birth Church of Christ International.
            </p>
          </div>

          <div className="board-grid">
            {members.map((m) => (
              <div key={m.name} className="member-card" onClick={() => setSelected(m)}>
                <div className="member-img-wrap">
                  <img src={m.img} alt={m.name} />
                  <div className="member-overlay">
                    <p>Click to read bio</p>
                  </div>
                </div>
                <div className="member-info">
                  <span className="member-location">📍 {m.location}</span>
                  <h3>{m.name}</h3>
                  <p>{m.title}</p>
                  <span className="member-exp">{m.experience}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="board-cta">
        <div className="container" style={{ textAlign: 'center' }}>
          <p className="section-label" style={{ color: 'var(--gold)' }}>Join Our Network</p>
          <h2 className="section-title" style={{ color: '#fff' }}>
            Are You a <span>Pastor or Church Leader?</span>
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.8)', maxWidth: '560px', margin: '0 auto 2rem', lineHeight: '1.8' }}>
            New Birth CCCI welcomes pastors and churches seeking fellowship, licensing, ministry support,
            and connection with a global community of believers. Reach out to us today.
          </p>
          <Link to="/contact" className="btn-primary-gold">Get In Touch</Link>
        </div>
      </section>

      <MemberModal member={selected} onClose={() => setSelected(null)} />
    </>
  );
}
